import React from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import PositionForm from '../Forms/PositionForm';

const AddEditPositionModal = ({ dataPosition, isOpen, isEdit, handleToggleModal, activeTab, toggleTab, }) => {
    return (
        <Modal
            isOpen={isOpen}
            toggle={handleToggleModal}
            scrollable={true}
            size='xl'
            className='border-0'
            modalClassName='modal fade zoomIn'
            backdrop={'static'}
            centered={true}
        >
            <ModalHeader toggle={handleToggleModal}>
                {isEdit ? 'Editar' : 'Agregar'} Cargo
            </ModalHeader>

            <div className='modal-content border-0'>
                <Nav className='nav-tabs nav-tabs-custom nav-success p-2 pb-0 bg-light'>
                    <NavItem>
                        <NavLink
                            href='#'
                            className={classnames({ active: activeTab === '1' })}
                            onClick={() => {
                                toggleTab('1');
                            }}
                        >
                            Información General
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            href='#'
                            className={classnames({ active: activeTab === '2' })}
                            onClick={() => {
                                toggleTab('2');
                            }}
                        >
                            Asignación de Personal
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            href='#'
                            className={classnames({ active: activeTab === '3' })}
                            onClick={() => {
                                toggleTab('3');
                            }}
                        >
                            Configuración de EPP
                        </NavLink>
                    </NavItem>
                </Nav>
            </div>

            <PositionForm
                dataPosition={dataPosition}
                isOpen={isOpen}
                isEdit={isEdit}
                handleToggleModal={handleToggleModal}
                activeTab={activeTab}
                toggleTab={toggleTab}
            />
        </Modal>
    );
};

export default AddEditPositionModal;